module.exports = __webpack_public_path__ + "static/media/mz.b330ef2a.svg";